import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { env } from "../../config/environment";

/**
 * Generated class for the AlipayPortalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-alipay-portal",
  templateUrl: "alipay-portal.html",
})
export class AlipayPortalPage {
  pristineAlipayLink = "";
  alipayLink = "";

  setAlipayLink() {
    setTimeout(() => {
      this.alipayLink = this.pristineAlipayLink;
      setTimeout(() => {
        (document.body.querySelector(".alipay-link") as any).select();
      });
    });
  }

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.pristineAlipayLink = env.server_url + "purchase/" + navParams.data.id;
  }

  ionViewDidEnter() {
    document.title = "支付宝付款";
    this.setAlipayLink();
  }
}



// WEBPACK FOOTER //
// ./src/pages/alipay-portal/alipay-portal.ts